import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProfileShortInfo, UserProfile } from '../model';
import { ShellService } from '@mynexus/mfe-core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  private internalUsersList: BehaviorSubject<ProfileShortInfo[]> = new BehaviorSubject([]);

  constructor(
    private http: HttpClient,
    private shellService: ShellService
  ) {
  }

  get getApiBaseUrl(){
    return this.shellService.getBaseUrlFor(this.shellService.getAppName())
  }

  getInternalADUsersShortInfoList(): Observable<ProfileShortInfo[]> {
    const list = this.internalUsersList.getValue();

    if (list.length) {
      return this.internalUsersList.asObservable();
    } else {
      return this.http.get<UserProfile[]>(`${this.getApiBaseUrl}/Graph/GetInternalUsersShortInfoList`)
        .pipe(
          map(r => {
            return r.map(item => ({
              emailAddress: item.email,
              name: item.displayName,
              userId: item.userId,
              isInternal : !item.isExternal
            }));
          }),
          tap((users) => this.internalUsersList.next(users))
        );
    }
  }
}
